'use client';

import { Button } from '@curology/ui-components-web/react/Button';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React, { useEffect, useState } from 'react';
import { type QuestionTextModel } from 'survey-core';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { useNavigation } from '@/components/flow/hooks/useNavigation';
import { InformationService } from '@/services/informationService/client';
import { type InformationData } from '@/services/informationService/types';

import BackButton from '../buttons/back';

const IsInformationAccurate = ({
  question,
}: {
  question: QuestionTextModel;
}) => {
  const { onBack } = useNavigation();
  const [isLoading, setIsLoading] = useState(true);
  const [informationData, setInformationData] = useState<InformationData[]>([]);
  const { treatmentCategory, brand } = useFlowContext();

  useEffect(() => {
    const getHealthHistoryInformation = async () => {
      const healthHistoryInformation =
        await InformationService.getHealthHistoryInformation(brand);
      setInformationData(healthHistoryInformation.data.data);
      setIsLoading(false);
    };
    getHealthHistoryInformation().catch(console.error);
  }, [treatmentCategory, brand]);

  const handleOnClick = (isInformationAccurate: string) => {
    question.value = isInformationAccurate;
    informationData.forEach((data) => {
      if (data.questionName) {
        const questionToSetValueFor = question.surveyModel.getQuestionByName(
          data.questionName,
        );
        questionToSetValueFor.value = data.value;
      }
    });
    question.surveyModel.nextPage() || question.surveyModel.completeLastPage();
  };

  return (
    <>
      <div role="presentation" className="cur-bg-surface-neutral">
        {informationData.map((data) => {
          return (
            <div
              key={data.title}
              className="cur-border-b-curology-primary-500 cur-border-b-2 cur-p-4"
            >
              <Typography size="h3">{data.title}</Typography>
              <Typography className="cur-leading-6">{data.value}</Typography>
            </div>
          );
        })}
      </div>
      <div className="cur-flex cur-flex-col cur-gap-y-2 cur-mt-6">
        <Button
          className="cur-w-full"
          disabled={informationData.length === 0}
          loading={isLoading}
          onClick={() => handleOnClick('yes')}
        >
          Yes, it&apos;s accurate
        </Button>
        <Button
          buttonType="secondary"
          className="cur-w-full"
          disabled={informationData.length === 0}
          loading={isLoading}
          onClick={() => handleOnClick('no')}
        >
          No, I&apos;d like to update
        </Button>
        <BackButton
          model={question.surveyModel}
          isFirstPage={question.surveyModel.isFirstPage}
          onFirstPageBack={onBack}
        />
      </div>
    </>
  );
};

export default IsInformationAccurate;
